import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icons in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

const venueIcon = new L.Icon({
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

export function LocationMap({ pickupPoints = [], venueLat, venueLng, venueLabel, className = "" }) {
  const markers = [];

  if (venueLat && venueLng) {
    markers.push({ lat: venueLat, lng: venueLng, label: venueLabel || "Venue", type: "venue" });
  }
  pickupPoints.forEach((p) => {
    if (p.lat && p.lng) {
      markers.push({ lat: p.lat, lng: p.lng, label: `${p.name}${p.time ? ` — ${p.time}` : ""}`, type: "pickup", address: p.address });
    }
  });

  if (markers.length === 0) return null;

  const center = [markers[0].lat, markers[0].lng];
  const bounds = markers.length > 1
    ? L.latLngBounds(markers.map((m) => [m.lat, m.lng]))
    : null;

  return (
    <div className={`rounded-xl overflow-hidden border border-border ${className}`} data-testid="location-map">
      <MapContainer
        center={center}
        zoom={12}
        bounds={bounds}
        boundsOptions={{ padding: [40, 40] }}
        scrollWheelZoom={false}
        style={{ height: "300px", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {markers.map((m, i) => (
          <Marker key={i} position={[m.lat, m.lng]} icon={venueIcon}>
            <Popup>
              <div className="text-sm">
                <strong>{m.label}</strong>
                {m.address && <div className="text-xs text-gray-500 mt-0.5">{m.address}</div>}
                <div className="text-xs mt-0.5 font-medium" style={{ color: m.type === "venue" ? "#0d9488" : "#ea580c" }}>
                  {m.type === "venue" ? "Venue" : "Pickup Point"}
                </div>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
